/* @ngInject */
function AddProductLoadingController ($scope, $translate, $sce) {
  const api = {}

  this.getApi = () => api

  activate()

  function activate () {}

  $scope.getLoadingText = () => {
    const loadingText = $translate.instant('productFrame.addProductModal.loadingText')
    return $sce.trustAsHtml(loadingText)
  }
}

export { AddProductLoadingController }
